import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { Button } from 'shared/components/Button/Button'
import { Handler } from 'shared/helpers/typeHelper'

import { NavLeft } from './NavLeft'

type BackProps = {
  children?: React.ReactNode
  onClick?: Handler
  href?: string
}

export function Back({ children, onClick, href }: BackProps) {
  return (
    <NavLeft>
      <Button variant="text" icon={<ArrowBackIcon fontSize="small" />} onClick={onClick} href={href}>
        {children || <>&nbsp;</>}
      </Button>
    </NavLeft>
  )
}
